module.exports = __webpack_public_path__ + "static/media/download-apk-phone.96045012.png";